import React, { useState } from "react";
import type { UploadProps } from "antd";
import { message, Upload } from "antd";
import UploadIcon from "../../assets/icons/UploadIcon";
import Colors from "../../config/Colors";
import { RcFile, UploadFile } from "antd/es/upload/interface";
import { API } from "../../config/axios";

type UploadDocumentProp = {
  actionURL: string;
  onComplete: (done: boolean) => void;
};

const UploadDocument = ({ actionURL, onComplete }: UploadDocumentProp) => {
  const { Dragger } = Upload;
  const [uploading, setUploading] = useState(false);

  const customRequest = async (options: any) => {
    const { file, onSuccess, onError, onProgress } = options;
    const formData = new FormData();
    formData.append("file", file);

    try {
      setUploading(true);
      const response = await API.post(actionURL, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / (progressEvent.total || 1)
          );
          onProgress({ percent: percentCompleted });
        },
      });

      onSuccess(response.data);
      message.success(
        `${file.name} file uploaded successfully. Job started successfully`
      );
      onComplete(true);
    } catch (error: any) {
      onError(error);
      message.error(
        error?.message || `${file.name} file upload failed.`
      );
      onComplete(false);
    } finally {
      setUploading(false);
    }
  };

  const props: UploadProps = {
    name: "file",
    multiple: false,
    customRequest,
    onChange(info) {
      const { status } = info.file;
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };

  const beforeUpload = (file: RcFile, fileList: UploadFile[]) => {
    const isExcelFile =
      file.type === "application/vnd.ms-excel" ||
      file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
      file.type === "application/vnd.oasis.opendocument.spreadsheet";

    if (!isExcelFile) {
      message.error("You can only upload Excel files!");
    }

    return isExcelFile;
  };
  return (
    <Dragger {...props} beforeUpload={beforeUpload}>
      <div className="ant-upload-drag-icon flex justify-content-center">
        <UploadIcon height={30} width={30} svgColor={Colors.appMainColor} />
      </div>
      <div className="ant-upload-text mt-4">
        Drop your files here or click here to upload
      </div>
    </Dragger>
  );
};

export default UploadDocument;
